import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Content, Flex, Text, Button, List, CompositeTextInput, Pane } from '@leverege/ui-elements';
import { ApiProvider } from '@leverege/api-redux';
import { TitleBar } from '@leverege/ui-plugin';
import S from './DeviceSearch.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function DeviceSearch(props) {
  const {
    value,
    onClick,
    onChange,
    eventData,
    actions,
    pairing = true,
    titleVariant,
    titleIcon,
    onClose,
    getSearchText
  } = props;
  const api = useContext(ApiProvider.Context);
  const [val, setVal] = useState(value);
  const [items, setItems] = useState([]);
  const isParent = eventData === 'desiredGatewayId';
  const itemName = isParent ? 'Installation Location' : 'Gateway';
  const onSearch = ({
    value
  }) => {
    setVal(value);
  };
  const onClear = () => {
    setVal(null);
  };
  const onSelect = useCallback(({
    data
  }) => {
    const netId = getSearchText(data);
    onSearch({
      value: null
    });
    onChange({
      data: eventData,
      value: netId,
      original: data
    });
  }, [onChange, getSearchText]);
  const searchIsValid = val && val.length > 2;
  useEffect(() => {
    if (searchIsValid) {
      api.child(`v1/interface/${actions.parent().getInterfaceUrl()}/${isParent ? 'desiredGateways' : 'gateways'}.search`).post({
        limit: 100,
        filter: {
          type: 'groupedText',
          value: `*${val}*`
          // operator : 'and',
          // conditions : [ {
          //   type : 'expression',
          //   value : `*${val.toLowerCase()}*`,
          //   field : `networkAliases/${nwkId}/${aliasKey}`,
          //   kind : 'queryString',
          //   analyzeWildcard : true,
          //   ignoreCase : true
          // } ]
        }
      }).then(res => {
        const {
          items: rItems
        } = res;
        setItems(rItems);
      }).catch(() => {});
    } else {
      setItems([]);
    }
  }, [val]);
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsxs(Content.Header, {
      layout: "flex:colL",
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          position: 'relative'
        },
        children: [/*#__PURE__*/_jsx(TitleBar, {
          variant: titleVariant,
          title: `Search ${itemName}`,
          icon: titleIcon
        }), /*#__PURE__*/_jsx(Button, {
          variant: "pairClose",
          className: S.close,
          onClick: onClose
        })]
      }), /*#__PURE__*/_jsxs(Pane, {
        variant: titleVariant,
        children: [/*#__PURE__*/_jsx(CompositeTextInput, {
          autoFocus: true,
          onFocus: () => {
            setTimeout(() => window?.scrollTo(0, 0), 250);
          },
          pre: /*#__PURE__*/_jsx(Button, {
            variant: "searchBack",
            eventData: {
              screen: 'main',
              field: null
            },
            onClick: onClick
          }),
          post: val && val.length > 0 && /*#__PURE__*/_jsx(Button, {
            variant: "pairClose",
            onClick: onClear
          }),
          variant: "fullWidth",
          value: val,
          onChange: onSearch,
          changeOnReturn: false,
          alwaysFireOnReturn: false
        }), items && items.length > 0 && /*#__PURE__*/_jsx(Text, {
          variant: "caption",
          className: S.resultCount,
          children: `${items.length} results`
        })]
      })]
    }), /*#__PURE__*/_jsx(Content.Area, {
      className: S.list,
      children: /*#__PURE__*/_jsx(Flex, {
        variant: "colL",
        children: items && items.length > 0 ? /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "subtitle",
            children: "Suggestions"
          }), /*#__PURE__*/_jsx(List, {
            variant: "pairingItem",
            onClick: onSelect,
            children: items.map(item => {
              return /*#__PURE__*/_jsx(ListItem, {
                getSearchText: getSearchText,
                item: item
              }, item.id);
            })
          })]
        }) : /*#__PURE__*/_jsx(React.Fragment, {
          children: searchIsValid ? /*#__PURE__*/_jsx(React.Fragment, {
            children: /*#__PURE__*/_jsxs(Text, {
              children: ["The ", itemName, " ", val, " does not exist in the system", isParent ? '.' : ` or is ${pairing ? 'already' : 'not'} paired to an Installation Location.`]
            })
          }) : /*#__PURE__*/_jsx(Text, {
            children: "Enter at least 3 characters to search."
          })
        })
      })
    })]
  });
}
function ListItem(props) {
  const {
    item,
    getSearchText,
    ...rest
  } = props;
  return /*#__PURE__*/_jsx(List.Item, {
    className: S.suggestion,
    item: item,
    ...rest,
    children: /*#__PURE__*/_jsx(Text, {
      variant: "pairing-suggestion",
      icon: "fa fa-search",
      children: getSearchText(item)
    })
  });
}